import ko from 'knockout';
import _ from 'underscore';
import { KoSchema } from '@bingads-webui/ko-schema';

export default class ViewModel {
  constructor({
    deps,
    currentPartitionName,
  }) {
    this.deps = deps;
    this.currentPartitionName = currentPartitionName;
    this.availableDimensions = ko.observableArray([]);
    this.selectedDimensionId = ko.observable();
    this.selectedDimension = ko.observable();
    this.showLimitExceededWarning = ko.observable(false);
    this.showBulkPanel = ko.observable(false);
    KoSchema(this);
  }

  updateModel(productOptions) {
    this.availableDimensions(productOptions);
    this.selectedDimension = ko.computed(() => (
      _.find(productOptions, option => option.Id === this.selectedDimensionId())));
    this.headerText = ko.computed(() => {
      const selectedDimension = this.selectedDimension();
      return _.result(selectedDimension, 'DisplayName') === this.deps.i18nGlobal.getString('ProductCondition_Brand') ?
        this.deps.i18nGlobal.getString('ProductGroup_Subdivide_Title_Brand', this.currentPartitionName) :
        this.deps.i18nGlobal.getString('ProductGroup_Subdivide_Title', this.currentPartitionName);
    });
  }
}
